/** Same wire reasons as mixed-engine::engines::board_finish_reason. */
export function newGameFinishReason(game: string, state: unknown): string | null {
  const outcome = (state as {outcome?: {kind?: string; reason?: string; Win?: {reason?: string}; Draw?: {reason?: string}}}).outcome;
  if (!outcome) return null;
  const reasons: Record<string, Record<string, string>> = {
    Abalone: {SixOff:'abalone_six_off',NoMoves:'abalone_no_moves',PlyCap:'abalone_ply_cap'},
    Gomoku: {Five:'gomoku_five',BoardFull:'gomoku_board_full'},
    Kyoen: {Concyclic:'kyoen_concyclic',Collinear:'kyoen_collinear',NoMove:'kyoen_no_move',InvalidClaim:'kyoen_invalid_claim'},
    Trax: {Loop:'trax_loop',Line:'trax_line',MaxPlies:'trax_max_plies'},
    Amazons: {NoMoves:'amazons_no_moves',Territory:'amazons_territory'},
    ChuShogi: {RoyalCaptured:'chu_shogi_royal_captured',Checkmate:'chu_shogi_checkmate',Stalemate:'chu_shogi_stalemate',BareKing:'chu_shogi_bare_king',Sennichite:'chu_shogi_sennichite',BareKings:'chu_shogi_bare_kings',MaxPlies:'chu_shogi_max_plies',Resign:'resign',Timeout:'timeout',DrawAgreement:'draw_agreed'},
  };
  if (game === 'BridgeNT') return 'bridge_nt_dd_diff';
  const key = outcome.kind ?? outcome.reason ?? outcome.Win?.reason ?? outcome.Draw?.reason;
  return key ? reasons[game]?.[key] ?? null : null;
}
